import { queryOptions, useQuery } from '@tanstack/react-query';
import type { VisualizationDTO } from '@tempo-io/roadmap-dto';
import { viewQueryKeys } from '@/lib/query-keys/view';

const getTemporaryMockedVisualizations = async (
  loopId: number,
  organizationId: string,
): Promise<VisualizationDTO[]> => {
  return [
    {
      visualizationId: 1,
      organizationId: organizationId,
      viewId: loopId,
      type: 'table',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      visualizationId: 2,
      organizationId: organizationId,
      viewId: loopId,
      type: 'swimlane',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      visualizationId: 3,
      organizationId: organizationId,
      viewId: loopId,
      type: 'timeline',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
  ];
};

/**
 * Query options factory for fetching all views.
 */
export const getVisualizationsQueryOptions = ({
  orgId,
  loopId,
  viewId,
}: {
  orgId: string;
  loopId: number;
  viewId: number;
}) =>
  queryOptions({
    queryKey: viewQueryKeys.visualizations.all(loopId, viewId),
    queryFn: () => getTemporaryMockedVisualizations(loopId, orgId), // Replace with actual API call when loop views are supported
    enabled: !!loopId,
  });

export const useLoopViewVisualizations = ({
  orgId,
  loopId,
  viewId,
}: {
  orgId: string;
  loopId: number;
  viewId: number;
}) => {
  return useQuery({
    ...getVisualizationsQueryOptions({ orgId, loopId, viewId }),
    enabled: !!loopId && !!viewId,
  });
};
